import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BiChevronLeft } from "react-icons/bi";

const WalletAmount = () => {
    const navigate = useNavigate();
    return (
        <div className="p-6 bg-white min-h-screen font-sans border rounded-lg">
            <div className="text-[#FF9630] font-semibold text-lg mb-4 flex items-center">
                <BiChevronLeft size={24} className="mr-1" /> Wallet
            </div>

            {/* Wallet Balance */}
            <div className="bg-gray-100 p-4 rounded-lg flex items-center justify-between border border-gray-200">
                <div className="flex flex-col items-center mx-auto">
                    <p className="text-sm text-gray-500 text-center">Total Wallet Balance</p>
                    <p className="text-3xl font-semibold text-green-600 text-center">₹0</p>
                </div>
                <button
                    onClick={() => navigate('/profile/wallet-history')}
                    className="text-sm text-gray-500"
                >
                    Wallet Transaction History
                </button>
            </div>


            <div className="mt-6">
                <h3 className="text-lg font-semibold text-left">Top Up Wallet</h3>

                {/* Input for Custom Top-Up Amount */}
                <input
                    type="text"
                    placeholder="₹1000"
                    className="w-full mt-2 p-3 border border-gray-300 rounded-md text-green-600 focus:outline-none focus:border-gray-400"
                />

                {/* Amount Options */}
                <div className="flex gap-2 mt-4">
                    <button className="py-2 px-4 border rounded-md text-[#FF9630] border-[#FF9630] bg-white">₹500</button>
                    <button className="py-2 px-4 border rounded-md text-gray-700 border-gray-300 bg-white">₹1000</button>
                    <button className="py-2 px-4 border rounded-md text-gray-700 border-gray-300 bg-white">₹2000</button>
                </div>

                {/* Top-Up Button */}
                <button className="w-full mt-4 py-3 bg-[#FF9630] text-white font-semibold rounded-md hover:bg-[#FF9630]">
                    PROCEED TO TOP-UP
                </button>
            </div>

            {/* Rewards and Refund Section */}
            <div className="mt-6 space-y-2">
                <div className="flex justify-between items-center border border-gray-200 p-4 rounded-md bg-white shadow-sm">
                    <div>
                        <p className="font-semibold">Move On Wheels Rewards</p>
                        <p className="text-sm text-gray-500">25% Utilization On Cart Value</p>
                    </div>
                    <p className="font-semibold">₹500</p>
                </div>

                <div className="flex justify-between items-center border border-gray-200 p-4 rounded-md bg-white shadow-sm">
                    <div>
                        <p className="font-semibold">Refund</p>
                        <p className="text-sm text-gray-500">100% Utilization</p>
                    </div>
                    <p className="font-semibold">₹0</p>
                </div>
            </div>
        </div>
    );
};

export default WalletAmount;
